module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-33b5e01660eec13426bc11edabb4cec3.png";